import {
    ADD_NOTIFICATION_TEMPLATE,
    GET_NOTIFICATION_TEMPLATE,
    ALL_NOTIFICATION_TEMPLATE,
    EDIT_NOTIFICATION_TEMPLATE
 } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  data: null,
}

const NotificationTemplate = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION_TEMPLATE:
    case GET_NOTIFICATION_TEMPLATE:
      state = {
        ...state,
        loading: true,
      }
      break
    case ALL_NOTIFICATION_TEMPLATE:
      state = {
        ...state,
        loading: false,
        data: action.payload.data,
      }
      break
    case EDIT_NOTIFICATION_TEMPLATE:
      state = {
        ...state,
        loading: false,
      }
      break
    default:
      break
  }
  return state
}

export default NotificationTemplate